import styled from 'styled-components'
import {colors} from '../styles'

export default styled.hr`
  width: 50%;
  border: none;
  height: 0;
  margin: 2rem auto;
  border-bottom: 2px solid ${colors.blueText};
`



/** WEBPACK FOOTER **
 ** ./src/components/HR.js
 **/